import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideSectionLabel,
  GuideLead,
  GuideCallout,
  GuideCard,
  GuideCardGrid,
  GuideBlockList,
  GuidePillar,
  GuidePillarGrid,
} from "../GuideBlocks.js";

const ReducingMentalNoiseSection = ({ heading, accentIndex = 3, getVisual, getAccent }) => (
  <GuidePanel sectionId="reducing-mental-noise" heading={heading} accentIndex={accentIndex} getVisual={getVisual} getAccent={getAccent}>
    <GuideLead>Mental noise cannot be eliminated completely, but it can be managed.</GuideLead>
    <GuideSectionLabel>Effective practices</GuideSectionLabel>
    <GuideCardGrid columns={2}>
      <GuideCard
        iconKey="awareness"
        title="Observe before believing"
        description="Record the thought and examine it before accepting it as true."
      />
      <GuideCard iconKey="clarity" title="Structured Thinking">
        <GuideBlockList
          items={["Facts", "Assumptions", "Emotions", "Evidence", "Decisions"]}
        />
      </GuideCard>
      <GuideCard
        iconKey="energy"
        title="Pause before responding"
        description="Delay the response: name the event, note the interpretation, then choose the next action."
      />
      <GuideCard
        iconKey="growth"
        title="Change context"
        description="Step away — a short walk or a break interrupts the replay loop so you can return to the decision."
      />
    </GuideCardGrid>
    <GuideSectionLabel>Reflection questions</GuideSectionLabel>
    <GuideCardGrid columns={2}>
      <GuideCard iconKey="thinking" title="Instead of asking 'Why is this happening to me?'">
        <GuideBlockList
          items={[
            "What facts do I know?",
            "What story am I creating?",
            "What evidence supports it?",
            "What else could be true?",
            "What action is within my control today?",
          ]}
        />
      </GuideCard>
    </GuideCardGrid>
    <GuideSectionLabel>The Ahavibes Perspective</GuideSectionLabel>
    <GuideCallout variant="amber">
      Mental noise is not a weakness — it is the predictable result of a mind filling gaps in evidence with stories.
    </GuideCallout>
    <GuidePillarGrid columns={3}>
      <GuidePillar title="Recognize the noise">
        Notice when internal stories are competing with present facts.
      </GuidePillar>
      <GuidePillar title="Question assumptions">
        Develop the ability to separate observation from interpretation.
      </GuidePillar>
      <GuidePillar title="Respond with evidence">
        Replace reactive patterns with intentional, evidence-based responses.
      </GuidePillar>
    </GuidePillarGrid>
    <GuideCallout>
      The goal is not to silence the mind, but to reduce the noise so that reasoning, evidence, and
      deliberate action can be heard.
    </GuideCallout>
  </GuidePanel>
);

export default ReducingMentalNoiseSection;
